import _ from 'lodash';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import filter from 'lodash/filter';

const campaignHelpers = {};

campaignHelpers.prepForPush = (data) => {
  let { locations, manual_query_apikey } = data;
  let selected_locations = filter(locations, {value: true});
  let locations_array = [];

  if (selected_locations.length > 1) {
    selected_locations.map((loc) => locations_array.push(loc.apikey));

    data.campaign_type = 'locations';
    data.location_apikeys = locations_array;
  }

  if (selected_locations.length === 1) {
    selected_locations.map(loc => locations_array.push(loc.apikey));
    data.campaign_type = 'location';
    data.location_apikeys = locations_array;
  }

  if (locations.length === selected_locations.length) {
    data.campaign_type = 'vendor';
    data.vendor_apikey = locations[0].vendor_apikey;
  }

  if(manual_query_apikey) {
    data.campaign_type = 'custom';
  }

  data.delivery_method = 'text';
  data.delivery_type = 'vendor';
  data.delivery_date = moment(data.date_from + ' ' + data.start_time.format('HH:mm:ss')).format('YYYY-MM-DD HH:mm:ss Z');

  return data;
}

campaignHelpers.buildPhase1 = (fields) => {

  return fields;
}

campaignHelpers.addLocationsToMulti = (fields, allLocations, selected=[]) => {
  fields = JSON.parse(JSON.stringify(fields));
  fields.locations.value = allLocations.map((loc) => {
    return {
      apikey: loc.apikey,
      vendor_apikey: loc.vendor_apikey,
      name: loc.name,
      value: selected.includes(loc.apikey) ? true : false
    }
  });

  return fields;
}

campaignHelpers.prepRecurringForPush = (data) => {
  data.delivery_method = 'text';
  data.delivery_type = 'vendor';
  data.delivery_date = moment(data.start_date);
  data.status = 'recurring';

  return data;
}

export default campaignHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/campaign/buildValues.js
 **/